import isArray from 'lodash/isArray';
import Communication from './Communication';
import Util from './Util';

class ShipFromManager {
	static ZorbitWarehouses = [];

	static ShipFromAddresses = [];

	static init(callback) {
		this.fetchZorbitWarehouses(callback);
		this.fetchShipFromAddresses();
	}

	static async fetchZorbitWarehouses(callback) {
		const response = await Communication.getZorbitWarehouses();

		if (Communication.isSuccessful(response)) {
			const { data = {} } = response;
			const warehouses = isArray(data) ? Util.toCamelCase(data) : [];

			warehouses.forEach(warehouse => {
				warehouse.title = `${warehouse.address.city} - ${warehouse.address.stateProvince}`;
			});

			this.ZorbitWarehouses = [
				{
					warehouseId: '0',
					title: 'All',
				},
				...warehouses,
			];

			callback();
		}
	}

	static async fetchShipFromAddresses() {
		const response = await Communication.getShipFromContacts();

		if (Communication.isSuccessful(response)) {
			const { data = {} } = response;
			const shipFromAddresses = isArray(data) ? Util.toCamelCase(data) : [];

			this.ShipFromAddresses = [...shipFromAddresses];
		}
	}
}

export default ShipFromManager;
